import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { GetAgendaShiftQuery, GetAgendaShiftQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaShift, getAgendaUser, shiftsByComId, shiftsByUser, updateAgendaShift } from './queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Button, Col, Modal, Row, Spinner, Stack } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import Cookies from 'js-cookie';
import { enUS, fr } from 'date-fns/locale';
import CustomModal from '../../components/Modals/CustomModal';
import UserImage from '../../components/UserImage';
import Sidebar from '../services/Sidebar/Sidebar';
import useDateService from '../services/DateService';

const UsersView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // NAVIGATION
  const navigate = useNavigate();
  // DATE SERVICES
  const {getTIMEZONE, getDateMinusDays, getDatePlusDays} = useDateService();
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);


  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});
    
  const {data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaShiftQuery, GetAgendaShiftQueryVariables>
      (getAgendaShift, {variables: {
        shiftId: id, 
        // startAt: {gt: monday},//{gt: yesterday}, 
        // filter: {
        //   startAt: {gt: monday},//{gt: yesterday}, 
        //   stopAt: {lt: nextMonday},//{lt: tomorrow}, 
        //   // confirmed: {eq: true},
        //   deleted: {ne: true}
        // }
        }});

  const [fetchShiftsData, {data: shiftsData, loading: shiftsLoading, 
    error: shiftsError}] = useLazyQuery<ShiftsByComIdQuery, ShiftsByComIdQueryVariables>(shiftsByComId);

  const [doUpdateShift] = useMutation<UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables>(updateAgendaShift);
            // console.log(monday);

  // useEffect(() => {
  //   if (dataShifts && !loadingShifts) {
  //     fetchDataShifts({variables: {
  //       userId: id,
  //       startAt: { eq: new Date().toISOString() },
  //       // filter: { 
  //       //   stopAt: {lt: tomorrow},
  //       //   confirmed: {eq: true},
  //       //   suspended: {eq : false},
  //       //   deleted: {ne: true}}
  //       }});
  //     }
  //     // console.log("USERS ->", users);
  // }, [id]);
  
  const user = dataUser?.getAgendaUser;
  const shift = data?.getAgendaShift;

  useEffect(() => {
    document.title = t('title.shift');
  }, []);

  useEffect(() => {
    if (dataUser) {
        if (user?.comId) {
            if (shift?.startAt && shift?.stopAt) {
              const beforeDate = getDateMinusDays(shift?.startAt, 3);
              const afterDate = getDatePlusDays(shift?.stopAt, 3);
              fetchShiftsData({variables: {comId: user?.comId, //limit: 10, 
                  startAt: { between: [beforeDate, shift.stopAt] },
                  // limit: 6,
              filter: 
              {
                location: {eq: shift?.location},
                stopAt: {between: [shift.startAt, afterDate]}
              }}});
            }
        }
    }
  }, [data, dataUser]);

  const shifts = (shiftsData?.shiftsByComId?.items || []);

  const acceptShift = async (shiftId: string) => {
    try {
        await doUpdateShift({
          variables: {
            input: {
              shiftId: shiftId,
              accepted: true,
            },
          },
        });
        setShowCustomModal(false);
        refetch();
    } catch(error) {
        alert("Error on Shift Acceptation");
    };
  };

  const confirmShift = async (shiftId: string, value: boolean) => {
    try {
        await doUpdateShift({
          variables: {
            input: {
              shiftId: shiftId,
              confirmed: value,
            },
          },
        });
        setShowCustomModal(false);
        refetch();
    } catch(error) {
        alert("Error on Shift Acceptation");
    };
  };
  
  // console.log(dataShifts?.shiftsByUser);
  if (!shift || !user) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }

  const startAt = new Date(shift.startAt);
  startAt.setHours(startAt.getHours() - TIMEZONE);
  const stopAt = new Date(shift.stopAt);
  stopAt.setHours(stopAt.getHours() - TIMEZONE);

  const applyOnShift = (shiftId: string) => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.acceptedMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ () => acceptShift(shiftId)}>
              {t('shift.accept')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  }

  const confirmOnShift = (shiftId: string) => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.confirmedMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ () => confirmShift(shiftId, true)}>
              {t('shift.confirm')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  }

  const goToShift = (id: string) => {
    navigate(t('link.shift') + '/' + id);
  } 
  // shifts.filter((item) => item?.shiftId !== shift.shiftId).slice(0, 4).map((job, index) => {
  //   console.log(job);
  // });
  // console.log('SH: ', shifts)
  return (
    <>
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <Stack direction="horizontal" gap={3} className="flex-wrap pt-3">
            { shifts.filter((item) => (item as any)?.user.userId !== AuthUserId).map((job) => (
                <>
                <div
                    className="p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
                    key={`user_${user.userId}`}
                >
                    <Row className="g-3 align-items-start">
                    {/* Avatar */}
                    <Col xs={12} md={6} className="d-flex flex-column align-items-start flex-shrink-0 w-auto">
                        <Link to={`${t('link.user')}/${(job as any).user.userId}`} className="text-decoration-none text-dark fw-bold link">
                            <UserImage user={(job as any).user} customClass="coworker_md shadow-sm hover:shadow-md" key={"worker_" + job?.userId} />
                        </Link>
                    </Col>

                    {/* Infos utilisateur */}
                    <Col className="ps-3">
                        <h5 className="mb-1">
                        <Link to={`${t('link.user')}/${(job as any).user.userId}`} className="text-decoration-none text-dark fw-bold link">
                            {(job as any).user.username}
                        </Link>
                        </h5>
                        <p className="text-muted mb-0">{(job as any).user.email}</p>
                    </Col>
                    <Col className="ps-3">
                        <p>{job?.role}</p>
                        <p>{job?.location}</p>
                        <p>{job?.info}</p>
                    </Col>
                    </Row>
                </div>
                </>
            ))}
          </Stack>
        </div>
      </div>
    </>
  );
};

export default UsersView;


